export default [
  { id: 'Agro', label: 'Agro' },
  { id: 'Alimentício', label: 'Alimentício' },
  { id: 'Atacado', label: 'Atacado' },
  { id: 'Comunicação', label: 'Comunicação' },
  { id: 'Construção', label: 'Construção' },
  { id: 'Consultoria', label: 'Consultoria' },
  { id: 'Contabilidade', label: 'Contabilidade' },
  { id: 'Educacional', label: 'Educacional' },
  { id: 'Energia', label: 'Energia' },
  { id: 'Financeiro', label: 'Financeiro' },
  { id: 'Industrial', label: 'Industrial' },
  { id: 'Jurídico', label: 'Jurídico' },
  { id: 'Logística', label: 'Logística' },
  { id: 'Manufatura', label: 'Manufatura' },
  { id: 'Não tenho informação', label: 'Não tenho informação' },
  { id: 'Saúde', label: 'Saúde' },
  { id: 'Serviços', label: 'Serviços' },
  { id: 'Tecnologia', label: 'Tecnologia' },
  { id: 'Turismo', label: 'Turismo' },
  { id: 'Varejo', label: 'Varejo' },
  { id: 'Outros', label: 'Outros' }
]
